import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';

import Icon from '@components/Icon.vue';

import { faSidebar } from '@icons/regular/faSidebar';

export interface FormStepConfig {
  title: string;
  subtitle?: string;
  autoProgress?: boolean;
  completed: boolean;
}

export interface Props {
  steps: FormStepConfig[];
}

interface HeaderElement extends FormStepConfig {
  id: string;
  index: number;
  isClickable: boolean;
  isActive: boolean;
  isCompleted: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StepForm',
  props: {
    steps: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  steps: FormStepConfig[];
};



const sidebarOpen = ref(true);

const currentStepIndex = ref(0);

const currentStep = computed(() => {
  return props.steps[currentStepIndex.value] as FormStepConfig;
});

const isCurrentStepCompleted = computed(() => {
  return currentStep.value.completed;
});

const isOnFinalStep = computed(() => {
  return currentStepIndex.value === props.steps.length - 1;
});

const headerElements = computed(() => {
  return props.steps.map((step, index) => {
    const id = `step-${index + 1}`;

    const isActive = index === currentStepIndex.value;
    const isCompleted = step.completed;

    let isClickable;

    if (step.completed) {
      isClickable = true;
    } else {
      const previousStep = props.steps[index - 1];

      if (previousStep?.completed) {
        isClickable = true;
      } else {
        isClickable = false;
      }
    }

    return {
      ...step,
      id,
      index,
      isClickable,
      isActive,
      isCompleted,
    } as HeaderElement;
  });
});

// TODO: This probably could be done a little bit better...
const autoProgressionFlags: string[] = [];

watch(headerElements, (elements) => {
  for (const element of elements) {
    if (
      element.index === currentStepIndex.value &&
      element.completed &&
      element.autoProgress &&
      !autoProgressionFlags.includes(element.id)
    ) {
      autoProgressionFlags.push(element.id);

      nextStep();
    }
  }
});

function goToStep(element: HeaderElement) {
  if (!element.isClickable) return;

  currentStepIndex.value = element.index;
}

function nextStep() {
  if (currentStep.value.completed) {
    currentStepIndex.value++;
  }
}

function previousStep() {
  currentStepIndex.value--;
}

function toggleSidebar() {
  sidebarOpen.value = !sidebarOpen.value;
}

expose({
  isCurrentStepCompleted,
  isOnFinalStep,
  nextStep,
  previousStep,
});

return { __sfc: true,props, sidebarOpen, currentStepIndex, currentStep, isCurrentStepCompleted, isOnFinalStep, headerElements, autoProgressionFlags, goToStep, nextStep, previousStep, toggleSidebar, Icon, faSidebar }
}

})